import {isNullish} from '@dfinity/utils';
import {requestJwt} from '@junobuild/auth/delegation';
import {envGoogleClientId} from '../../core/utils/window.env.utils';
import {SignInMissingClientIdError} from '../types/errors';
import type {GoogleSignInRedirectOptions} from '../types/google';

export class GoogleProvider {
  /**
   * Initiates a Google sign-in flow.
   *
   * Depending on the environment or configuration, this may redirect the user
   * to Google's authentication screen or trigger a browser-native sign-in flow
   * (such as FedCM in the future).
   *
   * @param {Object} params - Parameters for the sign-in request.
   * @param {GoogleSignInRedirectOptions} [params.options] - Optional configuration for the sign-in request.
   *
   * @returns {Promise<void>} Resolves once the sign-in flow has been initiated.
   */
  async signIn({options = {}}: {options?: GoogleSignInRedirectOptions}) {
    const clientId = options?.redirect?.clientId ?? envGoogleClientId();

    if (isNullish(clientId)) {
      throw new SignInMissingClientIdError();
    }

    const {redirect} = options;

    await requestJwt({
      google: {
        redirect: {
          ...(redirect ?? {}),
          clientId
        }
      }
    });
  }
}
